const customIconStyles = {
  centerAlignedBox: {
    // ...centerItemFlex,
  },
} as const;

export default customIconStyles;
